import React from 'react'

/**
 * @uiComponent
 */
export const UIFragment: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>
}
